export default __webpack_public_path__ + "static/media/012-dive light.ba5ff611.svg";